/**
 * @generated SignedSource<<0d945c28560d1fcd1287761e0e873d3b>>
 * @relayHash f6dca0e27b06d5f2d933636705547637
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f36e5b2969c282ec4e870b064f7d4fdebb8fd0fc64a53accbd9c74952b276e0

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PrefetchTelepointerAvatarsQuery$variables = {
  accountId: string;
  shouldFetchAvatar: boolean;
};
export type PrefetchTelepointerAvatarsQuery$data = {
  readonly user?: {
    readonly name: string;
    readonly picture: AGG$URL;
    readonly " $fragmentSpreads": FragmentRefs<"avatarRelay_user">;
  } | null;
};
export type PrefetchTelepointerAvatarsQuery = {
  response: PrefetchTelepointerAvatarsQuery$data;
  variables: PrefetchTelepointerAvatarsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetchAvatar"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PrefetchTelepointerAvatarsQuery",
    "selections": [
      {
        "condition": "shouldFetchAvatar",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "avatarRelay_user"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrefetchTelepointerAvatarsQuery",
    "selections": [
      {
        "condition": "shouldFetchAvatar",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appType"
                  }
                ],
                "type": "AppUser"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f6dca0e27b06d5f2d933636705547637",
    "id": "7f36e5b2969c282ec4e870b064f7d4fdebb8fd0fc64a53accbd9c74952b276e0",
    "metadata": {},
    "name": "PrefetchTelepointerAvatarsQuery",
    "operationKind": "query",
    "text": "query PrefetchTelepointerAvatarsQuery($accountId:ID!,$shouldFetchAvatar:Boolean!){user(accountId:$accountId)@include(if:$shouldFetchAvatar){__typename,name,picture,...avatarRelay_user,id}}fragment avatarRelay_user on User{__isUser:__typename,picture,...on AppUser{appType}}"
  }
};
})();

(node as any).hash = "b104e9896121c2e2b46c3765c8c2db1b";

export default node;
